/**
 * Fund READ endpoints — request schemas + wire types.
 *
 * Same category as the expense reads in `expensesReads.ts`: plain RLS-scoped
 * reads — the Hono handlers run the queries through the per-request user
 * client, so org RLS does the authorization (see docs/BACKEND_API.md →
 * "Read endpoints").
 *
 * The wire interfaces below are shared by the API handlers (response
 * construction) and the web hooks (unwrap<T> targets) so the two sides
 * cannot drift.
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Query-param schemas
// ---------------------------------------------------------------------------
/** Query params for GET /orgs/:orgId/funds. */
export const listFundsQuerySchema = z.object({
    projectId: z.string().uuid().optional(),
});
//# sourceMappingURL=fundsReads.js.map